import { User, userRoleValues } from '@_types/shared/User';
import LinkButton from '@components/button/LinkButton';
import ContentBlock from '@components/layout/contentBlock/ContentBlock';
import ContentItem from '@components/layout/contentBlock/ContentItem';
import ContentRow from '@components/layout/contentBlock/ContentRow';
import ButtonRow from 'lib/src/components/button/ButtonRow';
import dayjs from 'dayjs';
import EditPasswordModal from './EditPasswordModal';
import { useHistory } from 'react-router-dom';
import MfaSetupModal from './MfaSetupModal';

const ProfileInner: React.FC<ProfileInnerProps> = ({ profile, action }) => {
    const history = useHistory();

    return (
        <>
            <ContentBlock>
                <ContentRow>
                    <ContentItem label="Name">
                        <p>{`${profile.firstName} ${profile.lastName}`}</p>
                    </ContentItem>
                    <ContentItem label="Email">
                        <p>{profile.email}</p>
                    </ContentItem>
                    <ContentItem label="Roles">
                        <p>{profile.roles.map(role => userRoleValues[role]).join(', ')}</p>
                    </ContentItem>
                </ContentRow>
                <ContentRow>
                    <ContentItem label="MFA Enabled">
                        <p>{profile.hasMfa ? 'Yes' : 'No'}</p>
                    </ContentItem>
                    <ContentItem label="MFA Enabled On">
                        <p>
                            {profile.mfaEnabledOn
                                ? dayjs(profile.mfaEnabledOn).format('DD/MM/YYYY HH:mm')
                                : 'N/A'}
                        </p>
                    </ContentItem>
                    <ContentItem></ContentItem>
                </ContentRow>
            </ContentBlock>
            <ButtonRow alignment="left">
                <LinkButton color="grey" href={`/profile/edit-password`}>
                    Edit password
                </LinkButton>
                {!profile.hasMfa && (
                    <LinkButton color="green" href={`/profile/setup-mfa`}>
                        Set up MFA
                    </LinkButton>
                )}
            </ButtonRow>

            {action === 'edit-password' && (
                <EditPasswordModal closeModal={() => history.replace(`/profile`)} />
            )}

            {action === 'setup-mfa' && !profile.hasMfa && (
                <MfaSetupModal closeModal={() => history.replace(`/profile`)} />
            )}
        </>
    );
};

interface ProfileInnerProps {
    profile: User;
    action?: string;
}

export default ProfileInner;
